import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PatientLoginService } from './patientLogin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../../../globals';
import { AuthenticationService } from '../services/authentication.service';
import { AuthenticationResponseModel } from '../model/authentication-response.model';
import { version } from 'src/environments/version';

@Component({
  standalone: false,
  selector: 'app-patient-login',
  templateUrl: './patientLogin.component.html',
  styleUrls: ['./patientLogin.component.scss']
})
export class PatientLoginComponent implements OnInit {

  constructor(
    private loginService: PatientLoginService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    public globals: Globals,
    private cdr: ChangeDetectorRef
  ) { }

  username: string;
  password: string;
  token:string;
  validated: boolean = false;
  isLoading: boolean = false;
  error = '';
  returnUrl: string;
  returnParams: any = false;
  logoUrl: string = '';
  appVersion: string = version;
  mounted: boolean = false;
  focusedField: string = '';

  ngOnInit() {

    // Trigger entrance animation after view init
    setTimeout(() => {
      this.mounted = true;
      this.cdr.detectChanges();
    }, 50);

    this.authService.getLocationLogo().subscribe({
      next: (logoData: any) => {
        this.logoUrl = logoData;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('error getting location logo: ' + error.message);
        this.logoUrl = '';
        this.cdr.detectChanges();
      }
    });

    //this.token = this.route.snapshot.queryParams['t'];
    this.username = this.route.snapshot.queryParams['u'];
    this.cdr.detectChanges();

    this.logout();
    if (localStorage.getItem('LoadedVersion') != version) {    
      console.log('app version mismatch, reloading...');
      localStorage.setItem('LoadedVersion', version);
      localStorage.setItem('LoadedVersionDate', new Date().toLocaleString());
      window.location.href = window.location.href + '?t=' + Date.now();
      return;
    }
    if (localStorage.getItem("returnURL")) {
      this.returnUrl = localStorage.getItem("returnURL");
      localStorage.removeItem("returnURL");
    } else {
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    if (localStorage.getItem("returnURLParameters")) {
      this.returnParams = JSON.parse(localStorage.getItem("returnURLParameters"));
      localStorage.removeItem("returnURLParameters");
    }

  }

  logout() {
    this.authService.logout();
    return false;
  }

  onLoginPressed() {
    this.isLoading = true;
    this.error='';
    this.loginService.authenticatePatient(this.username, this.password, this.token).subscribe((authData: AuthenticationResponseModel) => {

      this.isLoading = false;
      if (authData.isSuccess) {
        var res: any = authData;
        this.isLoading = false;


        if (this.storeToken(res)) {
          this.validated = true;
          localStorage.setItem("isPatientRole", "true");

          this.router.navigate(['/patientportal/home']);
          return;

        } else {
          this.error = 'token not returned';
          console.log('error: ', this.error);
        }
      }
      else {
        this.error = authData.message;
        console.log('login error: ', authData.message);
      }
      this.cdr.detectChanges();
    },
      (error) => {
        this.isLoading = false;
        console.log('error: ' + error.message);
        this.error = "Error processing Token Login.";
        this.cdr.detectChanges();
      });
  }

  RequestToken() {
    this.error = '';
    this.username = this.username?.trim() || '';
    if (this.username === '') {
      this.error = 'Username or Email is required';
      return;
    }
    this.isLoading = true;
    this.error='';
    this.loginService.requestAuthToken(this.username).subscribe((authData: AuthenticationResponseModel) => {
      this.isLoading = false;
      if (authData.isSuccess) {
        //var res: any = authData;
        this.isLoading = false;
        this.token = authData.token;
      }
      else {
        this.error = authData.message;
        console.error('login error: ', this.error);
      }
      this.cdr.detectChanges();
    },
      (error) => {
        console.error("requestAuthToken error", error);
        this.isLoading = false;
        this.error = "Error processing Token request.";
        this.cdr.detectChanges();
      });
  }


  onCancelPressed() {
    this.username = '';
    this.password = '';
    this.token = '';
    this.validated = false;
    this.isLoading = false;
    this.error = null;
  }

  storeToken(userInformation: any): boolean {
    const stored = this.authService.storePatientTokenResult(userInformation);
    return stored;
  }

  getstoredToken(): string {
    return localStorage.getItem("TDOPatientAuthToken");
  }

  loginShortcut() {
    this.onLoginPressed();
  }

}
